import React, { Component } from 'react'
import { IframePowerBi } from '../../general/IframePowerBi';
import { obtenerValoresFiltros } from '../../../global/js/funciones';

class AdminPowerBi extends Component {
  state = {
    linkReporte: ''
  };

  async componentDidMount() {
    this.setState({ linkReporte: (await obtenerValoresFiltros([{ llave: 'codigo', valor: 'power_bi_semillero' }, { llave: 'estado', valor: '1' }]))[0].valora || "" })
  }


  render() {
    const { linkReporte } = this.state;

    return (
      <div style={{ width: '100%', minHeight: '100vh', display: 'flex', justifyContent: 'center', paddingTop: '20px', paddingBottom: '30px' }}>
        {linkReporte && <IframePowerBi title="Informes semilleros" style={{ width: '100%', height: '100vh', border: 'none' }} src={linkReporte} />}
      </div>
    );
  }
}

export default AdminPowerBi;
